import styles from './CategorySubtitle.module.scss'

export const CategorySubtitle = ({ subtitle }: { subtitle: string }) => {
  return <span className={styles.subtitle}>{subtitle}</span>
}
